import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from '@material-ui/core';


import { getLanguages, getFieldOfInterest } from '../../../api_handlers/influencer.js';

import AboutYourselfForm from '../forms/AboutYourself';
import MobileAboutYourselfForm from '../forms/MobileAboutYourself';


class AboutYourself extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languages: [],
      fieldOfInterest: [],
      selectedLanguages: [],
      selectedFieldOfInterest: [],
      aboutYourself: '',
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    this.setState({
      languages: await getLanguages(),
      fieldOfInterest: await getFieldOfInterest(),
    });
  }

  collectFormData() {
    let formData = {};

    if (Object.keys(this.state.selectedFieldOfInterest).length > 0) {
      formData['field_of_intrest'] = this.state.selectedFieldOfInterest.map((foi) => foi.id);
    }

    if (Object.keys(this.state.selectedLanguages).length > 0) {
      formData['language_known'] = this.state.selectedLanguages.map((language) => language.id);
    }

    if (this.state.aboutYourself) formData['about'] = this.state.aboutYourself;

    return formData;
  }

  async submitForm() {
    this.form.submitForm();
  }

  get_form() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      return (
        <AboutYourselfForm onRef={(ref) => (this.form = ref)} callback={this.props.handleNext} />
      );
    } else {
      return (
        <MobileAboutYourselfForm
          onRef={(ref) => (this.form = ref)}
          callback={this.props.handleNext}
        />
      );
    }
  }

  render() {
    return (
      <>
        {this.get_form()}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 24 }}>
          <Button
            variant="contained"
            onClick={() => {
              this.submitForm();
            }}
            style={{
              background: '#111936',
              color: 'white',
              padding: '8px 28px',
              fontWeight: 700,
              textTransform: 'none',
            }}
          >
            Save and Continue
          </Button>
        </div>
      </>
    );
  }
}

export default withRouter(AboutYourself);
